import type { FunctionComponent } from "react";

type MessageInputProps = {
  onChange: (message: string) => void;
  message: string;
  placeholder?: string;
};

export const MessageInput: FunctionComponent<MessageInputProps> = ({
  onChange,
  message = "",
  placeholder = "",
}: MessageInputProps) => {
  return (
    <textarea
      name="customerMessage"
      id="customerMessage"
      value={message}
      onChange={(e) => onChange(e.target.value)}
      className={"border border-neutral-500 rounded shadow py-2 px-3 my-2 w-full"}
      cols={30}
      rows={3}
      maxLength={500}
      placeholder={placeholder}
    />
  );
};
